import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { HistoryCounterContext } from '~/routes/HistoryCounter';
import { HOME_PATH } from '~/routes/paths';

type TOnBackCallback = () => void;

export default (fallbackPath?: string): TOnBackCallback => {
  const canBack = useContext(HistoryCounterContext) > 0;
  const history = useHistory();
  const { pathname } = useLocation();
  const paths = pathname.split('/');

  return useCallback(() => {
    if (canBack) {
      history.goBack();
    } else if (paths.length > 1) {
      history.replace(fallbackPath ?? `/${paths.slice(-2)[0]}`);
    } else {
      history.push(fallbackPath ?? HOME_PATH);
    }
  }, [canBack, history, paths, fallbackPath]);
};
